import { graphql, Link, useStaticQuery } from "gatsby"
import React from "react"
import Button from "../../../shared/components/atoms/button/button"
import { siteUrl } from "../../../shared/utils/siteUrl"
import DataPolicy from "../../../shared/components/atoms/data-policy/data-policy"
import "./step1-register.scss"
import useDataPolicy from "../../../shared/hooks/useDataPolicy"
import { registerStepDatalayer } from "../../../utils/registerDatalayer"

const Step1Register = props => {
  const { checksPolicy } = useDataPolicy()

  const resultQuery = useStaticQuery(
    graphql`
      query TYC_STEPS_QUERY_1 {
        allContentfulNolFooter {
          nodes {
            node_locale
            redireccionPoliticaPrivacidadDatos
            redireccionTerminosYCondiciones
          }
        }
      }
    `
  )
  var footerInfo = resultQuery.allContentfulNolFooter.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0]

  const months = [
    {
      month: "Enero",
      number: 1,
    },
    {
      month: "Febrero",
      number: 2,
    },
    {
      month: "Marzo",
      number: 3,
    },
    {
      month: "Abril",
      number: 4,
    },
    {
      month: "Mayo",
      number: 5,
    },
    {
      month: "Junio",
      number: 6,
    },
    {
      month: "Julio",
      number: 7,
    },
    {
      month: "Agosto",
      number: 8,
    },
    {
      month: "Septiembre",
      number: 9,
    },
    {
      month: "Octubre",
      number: 10,
    },
    {
      month: "Noviembre",
      number: 11,
    },
    {
      month: "Diciembre",
      number: 12,
    },
  ]
  const presentYear = new Date().getFullYear()
  const [notErrors, setnotErrors] = React.useState(true)
  var max = 31
  const datesInMonth = e => {
    props.handleChange(e)
    const data = props.getValues()
    switch (data.month) {
      case "1":
      case "3":
      case "5":
      case "7":
      case "8":
      case "10":
      case "12":
        max = 31
        break
      case "4":
      case "6":
      case "9":
      case "11":
        max = 30
        break
      case "2":
        max = 29
        break
      default:
        max = 31
        break
    }
    if (parseInt(data.date) > max) {
      setnotErrors(false)
      if (e.target.name === "date") {
        props.setError("month", "max")
      } else {
        props.setError("date", "max")
      }
    } else {
      setnotErrors(true)
      if (e.target.name === "date") {
        props.clearErrors("month", "max")
      } else {
        props.clearErrors("date", "max")
      }
    }
  }

  var homeLink = siteUrl + "/"

  const getErrorsType = __type => {
    const __errors = Object.keys(props.errors).reduce((acumm, currentKey) => {
      return { ...acumm, [currentKey]: true }
    }, {})

    if (__type === "tycAccepted") {
      return (
        __errors["tycAccepted"] ||
        __errors["uytdAccepted"] ||
        __errors["pbAccepted"]
      )
    }
    if (__type === "date") {
      return __errors.date
    } 
    if (__type === "year") {
      return __errors.year
    }
  }

  const maxSelectableYear = () => {
    const currentYear = new Date().getFullYear()
    const years = 9
        return currentYear - years
           
}
const minSelectableYear = () => {
  const currentYear = new Date().getFullYear()
  const minimunYearsRegister = 99
  return currentYear - minimunYearsRegister
}

  return (
    <>
      <form
        onSubmit={
          notErrors
            ? props.handleSubmit(()=>{props.onSubmit();registerStepDatalayer({ category: 'registro_1', label: 'siguiente' });})
            : e => e.preventDefault()
        }
      >
        <div className="f-step-register-form">
          <label>¿CUÁL ES TU FECHA DE NACIMIENTO?</label>
          <p className="f-step-register-copy">
            Es importante que ingreses los datos correctos ya que no podrás
            cambiarlos.
          </p>
          <span className="f-step-register-form-error-generic">
            { getErrorsType('year') ? "*Fecha incorrecta": getErrorsType('date') && "*Fecha incorrecta"}
          </span>
          <div className="f-step-register-form-item f-step-register-form-item-list">
            <div>
              <input
                onChange={e => {
                  if (
                    e.target.value > max ||
                    e.target.value.toString().length > 2
                  ) {
                    props.setValue(
                      "date",
                      parseInt(e.target.value.toString().slice(0, -1))
                    )
                  }
                  props.setValue(
                    "date",
                    parseInt(e.target.value.toString().replace(/[e+-]/g, ""))
                  )
                  datesInMonth(e)
                }}
                name="date"
                type="number"
                autoComplete="off"
                className={
                  props.errors.date
                    ? "f-form-date f-error-value"
                    : "f-form-date"
                }
                id={"outlined-date"}
                placeholder={"Día"}
                pattern="\d*"
                maxLength="2"
                ref={props.register({
                  required: true,
                  min: 1,
                  max: 31,
                  pattern: /^[0-9]+$/,
                  maxLength: 2,
                })}
              />
            </div>
            <div>
              <select
                className={
                  props.errors.month
                    ? "f-form-month f-error-value"
                    : "f-form-month"
                }
                name="month"
                autoComplete="off"
                id={"outlined-month"}
                onChange={datesInMonth}
                ref={props.register({ required: true })}
              >
                <option value="" hidden>
                  Mes
                </option>
                {months.map(month => (
                  <option key={"month" + month.number} value={month.number}>
                    {month.month}
                  </option>
                ))}
              </select>
              <span className="icon-down icon-select" />
  
            </div>
            <div>
              <input
                className={
                  props.errors.year
                    ? "f-form-year f-error-value"
                    : "f-form-year"
                }
                onChange={e => {
                  if (
                    e.target.value.toString().length > 4 ||
                    e.target.value > presentYear
                  ) {
                    props.setValue(
                      "year",
                      parseInt(e.target.value.toString().slice(0, -1))
                    )
                  }
                  props.setValue(
                    "year",
                    parseInt(e.target.value.toString().replace(/[e+-]/g, ""))
                  )
                }}
                onBlur={datesInMonth}
                name="year"
                type="number"
                autoComplete="off"
                id={"outlined-year"}
                placeholder={"Año"}
                pattern="\d*"
                maxLength={presentYear}
                ref={props.register({
                  required: true,
                  pattern: /^[0-9]+$/,
                  min: minSelectableYear(),
                  max: maxSelectableYear(),
                })}
              />
            </div>
          </div>
          <span className="f-step-register-form-error-generic">
            {getErrorsType("tycAccepted") &&
              "*Debes aceptar todos los terminos"}
          </span>

          {/*checks legal*/}
          <div className="f-step-register-form-item-wrap ">
            {checksPolicy.map((item, index) => {
              return (
                <div>
                  <div className="f-step-register-form-checkBox">
                    <input
                      type="checkbox"
                      name={item.idPrincipal}
                      value="Bike"
                      onChange={props.handleChange}
                      ref={props.register({ required: true })}
                    />
                    <a
                      className="f-step-register-form-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={homeLink + item.redireccion}
                    >
                      {item.tituloPrincipal}
                    </a>
                    <span className="f-checkmark"></span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <DataPolicy />
        <div className="f-step-register-buttons ">
          <Button
            className="f-btn new-primary-pink short f-btn-form-nextStep"
            title="Siguiente"
            type="submit"
            />
          <Link 
            to="/" 
            className="f-btn new-primary-pink--outline short"
            onClick={()=> registerStepDatalayer({ category: 'registro_1', label: 'cancelar' })}
          >
            Cancelar
          </Link>
        </div>
      </form>
    </>
  )
}

export default Step1Register
